import {
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  ThemeProvider,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Link } from "react-router-dom";
import theme from "../../../config/theme";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import Group30 from "../../../assets/Group30.png";
import Group31 from "../../../assets/Group31.png";
import { StyledButton } from "../../../components/common/Button";

const Hero = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth="false">
        {isMobile ? (
          <Grid container>
            <Grid item xs={12}>
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    marginTop: "3.75rem",
                    fontWeight: 700,
                    fontSize: "2rem",
                    textAlign: "center",
                    "& span": {
                      color: "#212121",
                    },
                    "& span.blue": {
                      color: theme.palette.primary.main,
                    },
                  }}
                >
                  <span>Effortless</span> <br />
                  <span className="blue">organization,</span> <br />
                  <span>Endless</span> <br />
                  <span className="blue">Possibilities</span>
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    marginTop: "2.5rem",
                    fontSize: "0.75rem",
                    letterSpacing: "0.0048339875",
                    fontWeight: 400,
                    textAlign: "center",
                  }}
                >
                  Optimize your academy's operations and <br /> streamline your
                  workload effortlessly with <br /> Youstad for maximum success.
                </Typography>
                <Box
                  sx={{
                    marginTop: "3.75rem",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      width: "14.375rem",
                      height: "2.375rem",
                      backgroundColor: `${theme.palette.primary.main}`,
                      borderRadius: "1.02539375rem",
                    }}
                    component={Link}
                    to="/onboarding"
                  >
                    GET STARTED
                  </Button>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "2rem",
                  }}
                >
                  <Button
                    style={{
                      gap: "0.25rem",
                      fontWeight: 700,
                      fontSize: "0.625rem",
                      letterSpacing: "0.0534058125rem",
                    }}
                  >
                    REQUEST DEMO
                    <PlayArrowIcon
                      sx={{
                        color: `${theme.palette.primary.main}`,
                        border: `1px solid ${theme.palette.primary.main}`,
                        borderRadius: "50%",
                        height: "0.625rem",
                        width: "0.625rem",
                      }}
                    />
                  </Button>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box>
                <img
                  src={Group30}
                  alt=""
                  style={{
                    marginTop: "1.9375rem",
                    marginBottom: "3.6875rem",
                    height: "11.625rem",
                    objectFit: "contain",
                    width: "100%",
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box>
                <img
                  src={Group31}
                  alt=""
                  style={{
                    marginTop: "1.875rem",
                    marginBottom: "3.75rem",
                    height: "11.625rem",
                    objectFit: "contain",
                    width: "100%",
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        ) : (
          <Box sx={{ display: "flex", gap: "1rem" }}>
            <Box sx={{ display: "flex", alignItems: "flex-end", flex: "1" }}>
              <img
                src={Group30}
                alt=""
                style={{
                  marginTop: "20.4375rem",
                  height: "19.9375rem",
                  objectFit: "contain",
                }}
              />
            </Box>
            <Box sx={{ flex: "4" }}>
              <Typography
                variant="h2"
                sx={{
                  marginTop: "7.5rem",
                  fontWeight: 700,
                  fontSize: "3.125rem",
                  letterSpacing: "-0.03125",
                  textAlign: "center",
                  "& span": {
                    color: "#212121",
                  },
                  "& span.blue": {
                    color: theme.palette.primary.main,
                  },
                }}
              >
                <span>Effortless</span>{" "}
                <span className="blue">organization,</span> <br />
                <span>Endless</span> <span className="blue">Possibilities</span>
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  marginTop: "3.875rem",
                  fontSize: "1.125rem",
                  letterSpacing: "0.01",
                  textAlign: "center",
                  fontWeight: 400,
                }}
              >
                Optimize your academy's operations and streamline your workload
                effortlessly <br /> with Youstad for maximum success.
              </Typography>
              <Box
                sx={{
                  marginTop: "3.75rem",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <StyledButton
                  variant="contained"
                  width="15.4375rem"
                  height="3rem"
                  style={{ backgroundColor: `${theme.palette.primary.main}` }}
                  component={Link}
                  to="/onboarding"
                >
                  GET STARTED
                </StyledButton>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "2.75rem",
                  marginBottom: "6.5rem",
                }}
              >
                <Button
                  style={{
                    gap: "0.3125rem",
                    fontWeight: 700,
                    fontSize: "0.8125rem",
                    letterSpacing: "0.078125rem",
                  }}
                  component={Link}
                  to="/contact"
                >
                  REQUEST DEMO
                  <PlayArrowIcon
                    sx={{
                      color: `${theme.palette.primary.main}`,
                      border: `2.5px solid ${theme.palette.primary.main}`,
                      borderRadius: "50%",
                    }}
                  />
                </Button>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-end",
                flex: "1",
              }}
            >
              <img
                src={Group31}
                alt=""
                style={{
                  marginTop: "13.6475rem",
                  height: "26.7975rem",
                  objectFit: "contain",
                }}
              />
            </Box>
          </Box>
        )}
      </Container>
    </ThemeProvider>
  );
};

export default Hero;
